import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, TOKEN } from "../constants";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const hasContentType =
    config?.headers?.["Content-Type"] || config?.headers?.["content-type"];

  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${TOKEN}`,
    ...(hasContentType
      ? {}
      : {
        "Content-Type": "application/json",
      }),
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
    "Access-Control-Allow-Headers":
      "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
  };
  return config;
});

// Global error handling for Engin creation/update
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";

    // SESSION UNIQUE : cette session a été fermée par une nouvelle connexion ailleurs → on purge et
    // on renvoie vers l'écran de connexion (une seule fois, pour éviter toute boucle).
    const sessionState = error?.response?.headers?.["x-session-state"];
    const rawData = error?.response?.data;
    const superseded = sessionState === "SUPERSEDED"
      || (typeof rawData === "string" && rawData.includes("SESSION_SUPERSEDED"))
      || rawData?.code === "SESSION_SUPERSEDED";
    if (status === 401 && superseded && !window.__sessionSupersededHandled) {
      window.__sessionSupersededHandled = true;
      try { toast.warn("Votre session a été fermée par une nouvelle connexion."); } catch (e) { /* noop */ }
      try { sessionStorage.clear(); } catch (e) { /* noop */ }
      if (!window.location.pathname.includes("/connexion")) {
        setTimeout(() => { window.location.href = "/connexion"; }, 1500);
      }
      return Promise.reject(error);
    }

    // DOSSIER EN LECTURE SEULE : le serveur refuse toute écriture sur un dossier verrouillé (423 LOCKED).
    // On affiche le message métier (auteur/date/motif) renvoyé par la garde SinistreService.assertDossierMutable.
    if (status === 423) {
      const backendMessage = error?.response?.data?.message
        || (typeof error?.response?.data === "string" ? error.response.data : null)
        || "Dossier en lecture seule : modification impossible tant que le verrou n'est pas levé.";
      try { toast.error(backendMessage); } catch (e) { /* noop */ }
      return Promise.reject(error);
    }

    if (status === 400 && url.includes("/api/engin")) {
      const backendMessage = error?.response?.data?.error;
      if (backendMessage) {
        try {
          toast.error(backendMessage);
        } catch (e) {
          // noop if toast is unavailable in some contexts
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
